module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Score/assets/skip-e2e083a293146d3d4f806c4abfd91c94.svg";